import SuccessPurchaseSubscriptionDialog from "@/dialogs/success-purchase-subscription-dialog";
import { getCookie } from "@/shared";
import { EARLY_BIRD_COUPON } from "@/shared/constants";
import { useGetCurrentUserQuery } from "@/shared/services";
import { environment } from "@environment";
import { store, useAppSelector } from "@store";
import { getAccountSeats } from "@store/account/selectors";
import { closeDialog, openDialog } from "@store/dialogs";
import { getSelectedPlan } from "../utils";
import { loadPaddle } from "../utils/load-paddle";

declare const window: Window & { Rewardful: any };

const useInitiatePaddle = () => {
  const { data: me, isLoading } = useGetCurrentUserQuery();
  const seats = useAppSelector(getAccountSeats);

  const initiatePaddle = async ({
    period,
    title,
    isEarlyBirds,
  }: {
    period: string;
    title: string;
    isEarlyBirds: boolean;
  }) => {
    if (isLoading || !me?.email) {
      await new Promise<void>((resolve) => {
        const checkData = () => {
          if (!isLoading && me?.email) resolve();
          else setTimeout(checkData, 100);
        };
        checkData();
      });
    }

    // Paddle loads on the first checkout. The dialog may have closed while
    // it did, and the inline checkout needs its container.
    const Paddle = await loadPaddle().catch(() => null);
    if (!Paddle || !document.querySelector(".paddle-checkout-container"))
      return;

    Paddle.Checkout.open({
      ...getPaddleOptions({
        period,
        title,
        email: me?.email ?? "",
        quantity: Number(seats.additionalSeats) + Number(seats.planLimit),
        isEarlyBirds,
      }),
      successCallback: () => {
        store.dispatch(closeDialog("purchase-subscription"));
        store.dispatch(
          openDialog({
            id: "success-purchase-subscription",
            content: SuccessPurchaseSubscriptionDialog,
            props: {
              title,
            },
          }),
        );
      },
    });
  };

  return { initiatePaddle };
};

export default useInitiatePaddle;

const getPaddleOptions = ({
  period,
  quantity,
  title,
  email,
  isEarlyBirds,
}: {
  period: string;
  quantity: number;
  title: string;
  email: string;
  isEarlyBirds: boolean;
}) => {
  const plan = getSelectedPlan(period, title, isEarlyBirds);
  const referral = window.Rewardful?.referral;
  const passthrough = referral ? { rewardful: { referral: referral } } : {};
  let coupon = getCookie("sd-paddle-coupon") || undefined;
  if (isEarlyBirds) coupon = EARLY_BIRD_COUPON;
  return {
    method: "inline",
    frameTarget: "paddle-checkout-container",
    product: plan.id,
    coupon,
    email,
    allowQuantity: false,
    quantity: quantity,
    disableLogout: environment.env === "production" ? true : false,
    frameStyle: "position: static; width: 100%; min-height: 610px;",
    passthrough: JSON.stringify(passthrough),
  };
};
